export const css = {
	root: '_9WL1Bmij',
	' _key': 'table-of-contents/trigger'
};

export default css;
